// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Karla', 'Karla Fallback'","fontStyle":"normal"},"className":"__className_4e868f","variable":"__variable_4e868f"};